import { useEffect, useState } from "react";
import { useSystemMessage } from "../../../providers/SystemMessageContext";
import { useNavigate, useParams } from "react-router-dom";
import LoadingTakeover from "../../buffers/LoadingTakeover";
import { useGetExamComponentBaseQuery, useGetExamComponentQuery, usePostExamComponentMutation } from "../../../api";
import ExamComponentInstructionsTile from "../../widgets/ExamComponentInstructionsTile";
import getActiveExams from "./checkIfActiveExists";
import { Button, Stack, Modal } from "@mui/material";
import CountdownTimer from "../../utilities/CountdownTimer";
import { Paid } from "@mui/icons-material";
import "../../../App.scss";
import checkIfUngradedExists from "./checkIfUngradedExams";
import ConfirmActionModal from "../../modals/ConfirmActionModal";
import PlainModal from "../../modals/PlainModal";
import closeExams from "../../helpers/closeExams";

const ExamLaunchPad = () => {
    const { showMessage } = useSystemMessage();
    const navigate = useNavigate();
    const { exam_component_base_id } = useParams<{ exam_component_base_id: string }>();
    const { data: exam_component_base_data, loading: exam_component_base_loading } = useGetExamComponentBaseQuery(exam_component_base_id, null);
    const { data: exam_component_data, loading: exam_component_loading_data, refresh: refresh_exam_component } = useGetExamComponentQuery(null, exam_component_base_id);
    const { submit: create_exam_component, data: exam_component_created, error: exam_component_error} = usePostExamComponentMutation();
    const { submit: grade_exam_component, data: exam_component_graded, error: exam_component_graded_error} = usePostExamComponentMutation();

    const [gradeDisplay, setGradeDisplay] = useState(null);
    const [gradeModalOpen, setGradeModalOpen] = useState(false);
    const openGradeModal = () => setGradeModalOpen(true);
    const closeGradeModal = () => setGradeModalOpen(false);
    const [scoreViewModalOpen, setScoreViewModalOpen] = useState(false);
    const openScoreViewModal = () => setScoreViewModalOpen(true);
    const closeScoreViewModal = () => setScoreViewModalOpen(false);
    const [gradeExams, setGradeExams] = useState(false);

    const [newExamComponent, setNewExamComponent] = useState<any>(null);
    useEffect(() => {
        if (!newExamComponent) return;
        navigate(`/timed-exam-component/${newExamComponent.id}/${newExamComponent.exam_component_base}`);
    }, [newExamComponent]);

    useEffect(() => {
        if (exam_component_created) {
            setNewExamComponent(exam_component_created.data[0]);
        } else if (exam_component_error) {
            showMessage(exam_component_error.response.data.message, exam_component_error.response.data.success ? "success" : "error");
        }
    }, [exam_component_created, exam_component_error]);

    useEffect(() => {
        if (exam_component_graded) {
            if (!exam_component_graded.data) {
                showMessage(exam_component_graded.errors, "error");
                closeGradeModal();
                return;
            }
            showMessage(exam_component_graded.message, exam_component_graded.success ? "success" : "error");
            setGradeDisplay(exam_component_graded.data[0].passed);
            closeGradeModal();
            closeExams(exam_component_graded.data[0].id);
            refresh_exam_component();
        } else if (exam_component_graded_error) {
            showMessage(exam_component_graded_error.response.data.message, exam_component_graded_error.response.data.success ? "success" : "error");
        }
    }, [exam_component_graded, exam_component_graded_error])

    useEffect(() => {
        if (gradeDisplay === null) return;
        openScoreViewModal();
    }, [gradeDisplay])

    useEffect(() => {
        if (!gradeExams || ungradedExams?.length === 0) return;
        handleGradeExams(ungradedExams);
        setGradeExams(false);
    }, [gradeExams]);

    if (exam_component_base_loading || exam_component_loading_data) {
        return (
            <LoadingTakeover />
        )
    }

    const activeExams = getActiveExams(exam_component_data.data);
    const ungradedExams = checkIfUngradedExists(exam_component_data.data);
    
    const handleStartNewExam = async () => {
        await create_exam_component({
            "create": {
                "exam_component_base_id":exam_component_base_data.data[0].id
            }
        }).catch((error) => {
            return;
        });
    };

    const handleResumeCurrentExam = async () => {
        if (!activeExams) return;
        navigate(`/timed-exam-component/${activeExams[0].id}/${activeExams[0].exam_component_base}`);
    };

    const handleGradeExams = async (examComponentIds: number[] | undefined) => {
        await grade_exam_component({
            "grade": {
                "exam_component_ids": examComponentIds
            }
        });
    };


    return (
        <>
        <Modal
            open={gradeModalOpen}
            onClose={closeGradeModal}
        >
            <ConfirmActionModal
                actionString={'grade your exam. You will not be able to re-enter the exam once it is graded'}
                confirmationHook={setGradeExams}
                handleClose={closeGradeModal}
            />
        </Modal>
        <Modal
            open={scoreViewModalOpen}
            onClose={closeScoreViewModal}
        >
            <PlainModal
                headerString={gradeDisplay ? 'PASS' : 'FAIL'}
                action={closeScoreViewModal}
                handleClose={closeScoreViewModal}
            />
        </Modal>
        <ExamComponentInstructionsTile
            examComponentBase={exam_component_base_data.data}
        />
        <Stack direction='row' spacing={2} sx={{ alignItems:'center' }}>
            {activeExams?.length ? (
                <>
                    <CountdownTimer 
                        expiration={activeExams[0].expiration}
                    />
                    <Button 
                        variant="contained"
                        onClick={() => handleResumeCurrentExam()}

                    >
                        Resume Open Exam
                    </Button>
                </>
            ) : (
                <Button
                    variant="contained"
                    onClick={() => handleStartNewExam()}
                >
                Start New Exam<div className="token-count"><Paid />{exam_component_base_data.data[0].cost}</div>
                </Button>
            )}
            {(ungradedExams?.length) ? (
                <Button
                    variant="outlined"
                    onClick={openGradeModal}
                >
                    Grade Open Exam
                </Button>
            ) : (<></>)}
        </Stack>
        </>
    )
};

export default ExamLaunchPad;